package fr.frux.shared.data.local

import fr.frux.shared.domain.model.HarvestStatus
import fr.frux.shared.domain.model.PlantForm
import fr.frux.shared.domain.model.PlantingCount
import fr.frux.shared.domain.model.Site
import fr.frux.shared.domain.model.SiteAccessRule
import fr.frux.shared.domain.model.SiteHarvestSummary
import fr.frux.shared.domain.model.SitePlanting
import fr.frux.shared.domain.model.SpeciesRef
import fr.frux.core.database.Site as DbSite
import fr.frux.core.database.Site_planting as DbPlanting

/**
 * Ligne du cache vers le domaine. `null` si le droit d'accès porte une valeur inconnue (ligne
 * d'une version plus récente) : elle se filtre plutôt que de planter. Une plantation illisible
 * est écartée seule. Arbres et drapeaux du lecteur ne sont pas persistés. La prochaine récolte l'est sans son statut,
 * réputée `PLANNED` hors ligne.
 */
internal fun DbSite.toDomain(plantings: List<SitePlanting>): Site? {
    val rule = enumOrNull<SiteAccessRule>(access_rule) ?: return null
    return Site(
        id = id,
        name = name,
        description = description,
        latitude = latitude,
        longitude = longitude,
        accessRule = rule,
        managerName = manager_name,
        hasOwner = has_owner != 0L,
        plantings = plantings,
        treesCount = trees_count.toInt(),
        createdBy = created_by,
        createdByUsername = created_by_username,
        createdAtMillis = created_at,
        nextHarvest =
            next_harvest_at?.let { at ->
                SiteHarvestSummary(
                    id = next_harvest_id ?: return@let null,
                    scheduledAtMillis = at,
                    status = HarvestStatus.PLANNED,
                    hostedByOwner = next_harvest_hosted == 1L,
                )
            },
    )
}

internal fun DbPlanting.toDomain(): SitePlanting? {
    val form = enumOrNull<PlantForm>(species_form)
    val count = enumOrNull<PlantingCount>(count_estimate)
    if (form == null || count == null) return null
    return SitePlanting(
        id = id,
        species =
            SpeciesRef(
                id = species_id,
                commonNameFr = species_common_name_fr,
                scientificName = species_scientific_name,
                form = form,
            ),
        count = count,
        note = note,
    )
}
